// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_92-0";
export var optionCard = "_92-1";